module.exports = __webpack_public_path__ + "img/sim-card-explained-en.eff76e69.png";